import { useEffect, useState } from 'react';
import { collection, onSnapshot, query, where } from 'firebase/firestore';
import { db } from '../firebase';
import type { LiveMembership } from '../types/liveCall';

/**
 * The Monthly Coaching between the signed-in person and another, either way
 * round (they coach the other, or the other coaches them), active or ending.
 */
export function useMembershipWith(
  uid: string | null | undefined,
  otherId: string | null | undefined,
): { membership: LiveMembership | null; role: 'coach' | 'player' | null } {
  const [found, setFound] = useState<{ membership: LiveMembership | null; role: 'coach' | 'player' | null }>(
    { membership: null, role: null });
  useEffect(() => {
    if (!uid || !otherId) return;
    const live = ['active', 'cancelling'];
    const watch = (role: 'coach' | 'player') => onSnapshot(
      query(collection(db, 'liveMemberships'),
        where(role === 'coach' ? 'coachId' : 'playerId', '==', uid),
        where(role === 'coach' ? 'playerId' : 'coachId', '==', otherId),
        where('status', 'in', live)),
      (snap) => {
        const d = snap.docs[0];
        if (d) setFound({ membership: { ...(d.data() as LiveMembership), id: d.id }, role });
      },
      () => { /* not a member */ },
    );
    const a = watch('coach');
    const b = watch('player');
    return () => { a(); b(); };
  }, [uid, otherId]);
  return found;
}
